import { Message } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';

interface StatusInfo {
    text?: string;
    theme?: 'success' | 'warning';
    shouldHide?: boolean;
}

const ShoppingBasketStatusPill = ({
    coverableStatus
}: {
    coverableStatus?: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const getStatusInfo = (): StatusInfo => {
        switch (coverableStatus) {
            case 'Changed':
                return {
                    text: getHippoText('DSS-SHOPPING-BASKET-CHANGED'),
                    theme: 'warning'
                };
            case 'Calculated':
                return {
                    text: getHippoText('DSS-SHOPPING-BASKET-OVERLAY-CALCULATED'),
                    theme: 'success'
                };
            default:
                return {
                    shouldHide: true
                };
        }
    };

    const { text, theme, shouldHide } = getStatusInfo();

    return !shouldHide ? (
        <Message id="status-pill" title={text} className="paragraph--small" theme={theme} />
    ) : (
        <></>
    );
};
export default ShoppingBasketStatusPill;
